<template>
  <div class="v-spinner-icon-loader">

    <div class="circular">

      <div :class="loaderOptions.iconSvgName == 'amilIcon' ? 'icon-circle' : 'icon-circle circle__card'">

        <slot
          name="mainIcon">

          <component
            v-bind:is="iconSvgComponent"
          />
        </slot>
      </div>

      <div class="circle">

        <div class="bar left">
          <div class="progress"></div>
        </div>

        <div class="bar right">
          <div class="progress"></div>
        </div>
      </div>
    </div>

    <h1 class="h1">
      {{ loaderMessage }}
    </h1>
  </div>
</template>

<script>
export default {
  name: 'VSpinnerIconLoader',
  props: {
    loaderOptions: {
      iconSvgName: String,
      mainLoaderMessage: String,
      secondaryLoaderMessage: String,
      changeMessageLimitTime: Number,
    },
  },
  data: () => ({
    timer: 0,
  }),
  computed: {
    iconSvgName() {
      return this.loaderOptions?.iconSvgName || 'creditCard';
    },
    mainLoaderMessage() {
      return this.loaderOptions?.mainLoaderMessage || 'Validando os dados com seu convênio...';
    },
    secondaryLoaderMessage() {
      return this.loaderOptions?.secondaryLoaderMessage || 'Falta pouco...';
    },
    changeMessageLimitTime() {
      return this.loaderOptions?.changeMessageLimitTime || 20;
    },

    loaderMessage() {
      const message = (this.timer < this.changeMessageLimitTime)
        ? this.mainLoaderMessage
        : this.secondaryLoaderMessage;

      return message;
    },

    iconSvgComponent() {
      return `${this.iconSvgName}Svg`;
    },
  },

  mounted() {
    this.timeUpdater();
  },

  methods: {

    timeUpdater() {
      setInterval(() => {
        this.timer += 1;
      }, 1000);
    },
  },
};

</script>

<style lang="scss" scoped>
.v-spinner-icon-loader {
  align-items: center;
  display: flex;
  flex-direction: column;

  .circular {
    align-self: center;
    grid-row-start: 2;
    height: 100px;
    justify-self: center;
    position: relative;
    width: 100px;

    .circle {
      border-radius: 100%;
      box-shadow: none;
      height: 100%;
      position: absolute;
      width: 100%;
      z-index: 0;

      & svg {
        position: absolute;
        z-index: 3;
      }

      &__card {
        & svg path {
          fill: var(--color-primary);
        }
      }

      .bar {
        background: #fff;
        border-radius: 100%;
        clip: rect(0px, 100px, 100px, 50px);
        height: 100%;
        position: absolute;
        width: 100%;
        z-index: 2;

        &.right {
          transform: rotate(180deg);
          z-index: 2;

          .progress {
            animation: progress 15s linear 15s both;
          }
        }

        &.left .progress {
          animation: progress 15s linear both;
          z-index: 1;
        }

        .progress {
          background: var(--color-primary);
          border-radius: 100%;
          clip: rect(0px, 50px, 100px, 0px);
          height: 100%;
          position: absolute;
          width: 100%;
          z-index: 2;
        }
      }
    }

    .icon-circle {
      left: 50%;
      position: absolute;
      top: 50%;
      transform: translate(-50%, -50%);
      z-index: 1;

      .di:before {
        font-size: 32px;
      }
    }
  }

  .h1 {
    grid-row-start: 3;
    justify-self: center;
    margin-top: 30px;
  }
}

@keyframes progress {
  100% {
    transform: rotate(180deg);
  }
}
</style>
